// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================ */
/* MiniIOT Page                                  */
/* ============================================ */

.miniiot-page {
  flex: 1 1;
  padding: 24px;
  background-color: #0a0a0a;
  color: #ffffff;
  height: 100%;
  width: 100%;
  overflow-y: auto;
  margin: 0;
  box-sizing: border-box;
}

.miniiot-container {
  max-width: 1400px;
  margin: 0 auto;
}

/* Header */
.miniiot-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.miniiot-header-icon {
  width: 40px;
  height: 40px;
  background-color: #dc2626;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  flex-shrink: 0;
}

.miniiot-title {
  font-size: 24px;
  font-weight: 700;
  color: #ffffff;
  margin: 0;
  line-height: 1.2;
}

.miniiot-subtitle {
  font-size: 13px;
  color: #9ca3af;
  margin: 0;
}

/* Layout */
.miniiot-layout {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 16px;
}

@media (max-width: 1024px) {
  .miniiot-layout {
    grid-template-columns: 1fr;
  }
}

/* Sidebar */
.miniiot-sidebar-card {
  background-color: #1a1a1a;
  border-radius: 10px;
  border: 1px solid #2a2a2a;
  padding: 12px;
}

.miniiot-search-container {
  position: relative;
  margin-bottom: 12px;
}

.miniiot-search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #6b7280;
  pointer-events: none;
}

.miniiot-search-input {
  width: 100%;
  padding: 10px 16px 10px 40px;
  background-color: #0a0a0a;
  border: 1px solid #374151;
  border-radius: 8px;
  color: #ffffff;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
  box-sizing: border-box;
}

.miniiot-search-input::placeholder {
  color: #6b7280;
}

.miniiot-search-input:focus {
  border-color: #dc2626;
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.15);
}

/* Sites List */
.miniiot-sites-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: calc(100vh - 250px);
  overflow-y: auto;
}

.miniiot-sites-list::-webkit-scrollbar {
  width: 4px;
}

.miniiot-sites-list::-webkit-scrollbar-track {
  background: transparent;
}

.miniiot-sites-list::-webkit-scrollbar-thumb {
  background: #374151;
  border-radius: 4px;
}

/* Section Headers */
.miniiot-section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  margin-bottom: 6px;
}

.miniiot-section-header.online {
  margin-top: 0;
}

.miniiot-section-header.offline {
  margin-top: 0;
}

.miniiot-section-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.miniiot-section-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #9ca3af;
  flex: 1 1;
}

.miniiot-section-badge {
  font-size: 10px;
  font-weight: 700;
  color: #9ca3af;
  background-color: #2a2a2a;
  padding: 1px 7px;
  border-radius: 10px;
  min-width: 18px;
  text-align: center;
}

.miniiot-section-divider {
  height: 1px;
  background-color: #2a2a2a;
  margin: 12px 0;
}

.miniiot-section-empty {
  padding: 12px 8px;
  text-align: center;
}

.miniiot-section-empty p {
  font-size: 12px;
  color: #4b5563;
  margin: 0;
}

.miniiot-searching-indicator {
  color: #818cf8;
  text-transform: none;
  animation: miniiot-pulse 1.2s ease-in-out infinite;
}

@keyframes miniiot-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
}

.miniiot-site-item {
  width: 100%;
  text-align: left;
  padding: 12px;
  background-color: #0a0a0a;
  border: 2px solid #2a2a2a;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  color: inherit;
  font-family: inherit;
}

.miniiot-site-item:hover {
  border-color: #4b5563;
}

.miniiot-site-item.selected {
  border-color: #dc2626;
  background-color: rgba(220, 38, 38, 0.08);
}

.miniiot-site-item-content {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}

.miniiot-site-item-info {
  flex: 1 1;
  min-width: 0;
}

.miniiot-site-item-name {
  font-size: 13px;
  font-weight: 600;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.miniiot-site-item-neighborhood {
  font-size: 12px;
  color: #9ca3af;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.miniiot-site-item-serial {
  font-size: 11px;
  color: #6b7280;
  margin-top: 4px;
  font-family: 'SF Mono', 'Fira Code', 'Fira Mono', monospace;
}

/* Status Dot */
.miniiot-status-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  flex-shrink: 0;
  margin-top: 4px;
}

.miniiot-status-dot.status-online {
  background-color: #22c55e;
  box-shadow: 0 0 6px rgba(34, 197, 94, 0.5);
}

.miniiot-status-dot.status-offline {
  background-color: #ef4444;
  box-shadow: 0 0 6px rgba(239, 68, 68, 0.5);
}

.miniiot-status-dot.status-warning {
  background-color: #f59e0b;
  box-shadow: 0 0 6px rgba(245, 158, 11, 0.5);
}

.miniiot-status-dot.status-maintenance {
  background-color: #3b82f6;
  box-shadow: 0 0 6px rgba(59, 130, 246, 0.5);
}

.miniiot-status-dot.status-unknown {
  background-color: #6b7280;
}

/* Loading, Error, Empty States */
.miniiot-loading,
.miniiot-empty,
.miniiot-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 16px;
  text-align: center;
}

.miniiot-loading p,
.miniiot-empty p {
  font-size: 13px;
  color: #6b7280;
  margin: 8px 0 0;
}

.miniiot-error p {
  font-size: 13px;
  color: #ef4444;
  margin: 0 0 12px;
}

.miniiot-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid #2a2a2a;
  border-top-color: #dc2626;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

.miniiot-retry-btn {
  padding: 8px 16px;
  background-color: #dc2626;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.miniiot-retry-btn:hover {
  background-color: #b91c1c;
}

/* Main Panel */
.miniiot-detail-panels {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.miniiot-card {
  background-color: #1a1a1a;
  border-radius: 10px;
  border: 1px solid #2a2a2a;
  padding: 20px;
}

.miniiot-card-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 16px;
  gap: 12px;
}

.miniiot-card-title {
  font-size: 18px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 2px;
}

.miniiot-card-subtitle {
  font-size: 12px;
  color: #9ca3af;
  margin: 0;
}

/* Device Status Badge */
.miniiot-device-status-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.miniiot-status-indicator {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
}

.miniiot-status-indicator.status-online {
  background-color: #22c55e;
  box-shadow: 0 0 6px rgba(34, 197, 94, 0.5);
}

.miniiot-status-indicator.status-offline {
  background-color: #ef4444;
}

.miniiot-status-indicator.status-warning {
  background-color: #f59e0b;
}

.miniiot-status-indicator.status-maintenance {
  background-color: #3b82f6;
}

.miniiot-status-indicator.status-unknown {
  background-color: #6b7280;
}

.miniiot-status-text {
  font-size: 13px;
  font-weight: 600;
}

.miniiot-status-text.status-online {
  color: #22c55e;
}

.miniiot-status-text.status-offline {
  color: #ef4444;
}

.miniiot-status-text.status-warning {
  color: #f59e0b;
}

.miniiot-status-text.status-maintenance {
  color: #3b82f6;
}

.miniiot-status-text.status-unknown {
  color: #6b7280;
}

/* Info Grid */
.miniiot-info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

@media (max-width: 768px) {
  .miniiot-info-grid {
    grid-template-columns: 1fr;
  }
}

.miniiot-info-item {
  background-color: #0a0a0a;
  border-radius: 8px;
  padding: 12px;
  border: 1px solid #2a2a2a;
}

.miniiot-info-label {
  font-size: 11px;
  font-weight: 600;
  color: #6b7280;
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.miniiot-info-value {
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
}

.miniiot-info-value.mono,
.mono {
  font-family: 'SF Mono', 'Fira Code', 'Fira Mono', monospace;
}

.miniiot-info-label-with-action {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
}

.miniiot-info-label-icon {
  display: flex;
  align-items: center;
  gap: 6px;
}

.miniiot-info-date-block {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.miniiot-info-date-label {
  font-size: 11px;
  color: #6b7280;
}

.miniiot-refresh-btn {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  border-radius: 50%;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.2s;
}

.miniiot-refresh-btn:hover {
  background-color: #374151;
  color: #dc2626;
}

.miniiot-refresh-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Section Title */
.miniiot-section-title {
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Commands Grid */
.miniiot-commands-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

@media (max-width: 768px) {
  .miniiot-commands-grid {
    grid-template-columns: 1fr;
  }
}

.miniiot-command-group {
  display: flex;
  flex-direction: column;
}

.miniiot-command-btn {
  width: 100%;
  padding: 16px;
  background-color: #0a0a0a;
  border: 2px solid #2a2a2a;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  color: inherit;
  font-family: inherit;
}

.miniiot-command-btn:hover:not(:disabled) {
  border-color: #dc2626;
}

.miniiot-command-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.miniiot-command-btn:disabled:hover {
  border-color: #2a2a2a;
}

.miniiot-command-icon {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
}

.miniiot-command-icon.blue {
  background-color: rgba(59, 130, 246, 0.15);
  color: #3b82f6;
}

.miniiot-command-btn:hover:not(:disabled) .miniiot-command-icon.blue {
  background-color: rgba(59, 130, 246, 0.25);
}

.miniiot-command-icon.red {
  background-color: rgba(220, 38, 38, 0.15);
  color: #dc2626;
}

.miniiot-command-btn:hover:not(:disabled) .miniiot-command-icon.red {
  background-color: rgba(220, 38, 38, 0.25);
}

.miniiot-command-icon.yellow {
  background-color: rgba(245, 158, 11, 0.15);
  color: #f59e0b;
}

.miniiot-command-btn:hover:not(:disabled) .miniiot-command-icon.yellow {
  background-color: rgba(245, 158, 11, 0.25);
}

.miniiot-command-text {
  text-align: center;
}

.miniiot-command-name {
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 2px;
}

.miniiot-command-desc {
  font-size: 12px;
  color: #6b7280;
  line-height: 1.3;
}

/* Report Link */
.miniiot-report-link {
  margin-top: 8px;
  text-align: center;
}

.miniiot-report-link-btn {
  background: none;
  border: none;
  color: #6b7280;
  font-size: 12px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  transition: color 0.2s;
  font-family: inherit;
  text-decoration: underline;
}

.miniiot-report-link-btn:hover {
  color: #dc2626;
}

/* Info Command */
.miniiot-info-command-section {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #2a2a2a;
}

.miniiot-info-command-btn {
  width: 100%;
  padding: 10px 16px;
  background-color: #0a0a0a;
  border: 1px solid #2a2a2a;
  border-radius: 8px;
  color: #9ca3af;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-family: inherit;
}

.miniiot-info-command-btn:hover:not(:disabled) {
  border-color: #3b82f6;
  color: #3b82f6;
  background-color: rgba(59, 130, 246, 0.05);
}

.miniiot-info-command-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

/* Progress Bar */
.miniiot-progress-container {
  margin-top: 16px;
  padding: 12px;
  background-color: #0a0a0a;
  border-radius: 8px;
  border: 1px solid #2a2a2a;
}

.miniiot-progress-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.miniiot-progress-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #ffffff;
}

.miniiot-progress-percent {
  font-size: 13px;
  font-family: 'SF Mono', 'Fira Code', 'Fira Mono', monospace;
  color: #6b7280;
}

.miniiot-progress-bar {
  width: 100%;
  height: 6px;
  background-color: #2a2a2a;
  border-radius: 6px;
  overflow: hidden;
}

.miniiot-progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #dc2626, #ef4444);
  border-radius: 6px;
  transition: width 0.3s ease-out;
}

/* Empty State */
.miniiot-empty-state {
  background-color: #1a1a1a;
  border-radius: 10px;
  border: 1px solid #2a2a2a;
  padding: 80px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.miniiot-empty-title {
  font-size: 18px;
  font-weight: 600;
  color: #6b7280;
  margin: 16px 0 8px;
}

.miniiot-empty-desc {
  font-size: 14px;
  color: #4b5563;
  margin: 0;
  max-width: 320px;
}

/* Modal */
.miniiot-modal-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 50;
  padding: 16px;
  backdrop-filter: blur(4px);
}

.miniiot-modal {
  background-color: #1a1a1a;
  border-radius: 12px;
  border: 1px solid #2a2a2a;
  max-width: 720px;
  width: 100%;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);
}

.miniiot-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  border-bottom: 1px solid #2a2a2a;
}

.miniiot-modal-header-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.miniiot-modal-title {
  font-size: 18px;
  font-weight: 700;
  color: #ffffff;
  margin: 0;
}

.miniiot-modal-subtitle {
  font-size: 12px;
  color: #6b7280;
  margin: 2px 0 0;
}

.miniiot-modal-close {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  color: #6b7280;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.miniiot-modal-close:hover {
  background-color: #2a2a2a;
}

.miniiot-modal-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.miniiot-modal-body::-webkit-scrollbar {
  width: 4px;
}

.miniiot-modal-body::-webkit-scrollbar-thumb {
  background: #374151;
  border-radius: 4px;
}

/* Report Items */
.miniiot-report-item {
  padding: 16px;
  border-radius: 10px;
  border: 2px solid;
}

.miniiot-report-item.success {
  background-color: rgba(34, 197, 94, 0.05);
  border-color: rgba(34, 197, 94, 0.3);
}

.miniiot-report-item.error {
  background-color: rgba(239, 68, 68, 0.05);
  border-color: rgba(239, 68, 68, 0.3);
}

.miniiot-report-item-header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.miniiot-report-item-icon {
  flex-shrink: 0;
  margin-top: 2px;
}

.miniiot-report-item-details {
  flex: 1 1;
  min-width: 0;
}

.miniiot-report-item-title-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}

.miniiot-report-item-title {
  font-size: 15px;
  font-weight: 600;
  color: #ffffff;
  margin: 0;
}

.miniiot-report-badge {
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 4px;
}

.miniiot-report-badge.success {
  background-color: rgba(34, 197, 94, 0.15);
  color: #22c55e;
}

.miniiot-report-badge.error {
  background-color: rgba(239, 68, 68, 0.15);
  color: #ef4444;
}

.miniiot-report-message {
  font-size: 13px;
  margin: 0 0 8px;
}

.miniiot-report-message.success {
  color: #4ade80;
}

.miniiot-report-message.error {
  color: #f87171;
}

.miniiot-report-meta {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
  font-size: 12px;
}

.miniiot-report-meta-item {
  display: flex;
  gap: 6px;
}

.miniiot-report-meta-item.full {
  grid-column: 1 / -1;
}

.miniiot-report-meta-label {
  color: #6b7280;
}

.miniiot-report-meta-value {
  color: #ffffff;
  font-weight: 500;
}

/* Modal Footer */
.miniiot-modal-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-top: 1px solid #2a2a2a;
}

.miniiot-modal-count {
  font-size: 13px;
  color: #6b7280;
  margin: 0;
}

.miniiot-modal-count span {
  color: #ffffff;
  font-weight: 600;
}

.miniiot-modal-close-btn {
  padding: 8px 20px;
  background-color: #dc2626;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
  font-family: inherit;
}

.miniiot-modal-close-btn:hover {
  background-color: #b91c1c;
}

.miniiot-modal-empty {
  text-align: center;
  padding: 40px 16px;
}

.miniiot-modal-empty p {
  color: #6b7280;
  font-size: 14px;
}

/* ========== History Toggle Button ========== */
.miniiot-history-toggle-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 12px 16px;
  background: transparent;
  border: none;
  color: #a78bfa;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: color 0.2s, background-color 0.2s;
  border-radius: 8px;
  font-family: inherit;
}

.miniiot-history-toggle-btn:hover {
  color: #c4b5fd;
  background-color: rgba(139, 92, 246, 0.08);
}

.miniiot-history-toggle-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.miniiot-chevron {
  margin-left: auto;
  transition: transform 0.3s ease;
}

.miniiot-chevron.open {
  transform: rotate(180deg);
}

/* ========== History Panel ========== */
.miniiot-history-panel {
  max-height: 500px;
  display: flex;
  flex-direction: column;
}

.miniiot-history-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.miniiot-history-count {
  font-size: 12px;
  color: #9ca3af;
  background-color: rgba(255, 255, 255, 0.05);
  padding: 3px 10px;
  border-radius: 12px;
}

.miniiot-history-empty {
  text-align: center;
  padding: 30px 16px;
}

.miniiot-history-empty p {
  color: #6b7280;
  font-size: 14px;
  margin-top: 8px;
}

.miniiot-history-table-wrapper {
  overflow: auto;
  max-height: 400px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.miniiot-history-table-wrapper::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.miniiot-history-table-wrapper::-webkit-scrollbar-track {
  background: transparent;
}

.miniiot-history-table-wrapper::-webkit-scrollbar-thumb {
  background: #374151;
  border-radius: 3px;
}

.miniiot-history-table-wrapper::-webkit-scrollbar-thumb:hover {
  background: #4b5563;
}

.miniiot-history-table-wrapper::-webkit-scrollbar-corner {
  background: transparent;
}

.miniiot-history-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 12px;
  min-width: 580px;
}

.miniiot-history-table thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: #1e1b2e;
  color: #c4b5fd;
  font-weight: 600;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding: 10px 12px;
  text-align: left;
  white-space: nowrap;
  border-bottom: 2px solid rgba(139, 92, 246, 0.3);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
}

.miniiot-history-table td {
  padding: 8px 12px;
  color: #d1d5db;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
  white-space: nowrap;
}

.miniiot-history-table tbody tr:hover {
  background-color: rgba(255, 255, 255, 0.03);
}

.miniiot-history-table .mono {
  font-family: 'JetBrains Mono', 'Fira Code', monospace;
  font-size: 11px;
}

.miniiot-history-date {
  font-size: 11px;
  color: #9ca3af;
}

/* History status badge */
.miniiot-history-status-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
  text-align: center;
}

.miniiot-history-status-badge.status-online {
  background-color: rgba(34, 197, 94, 0.15);
  color: #4ade80;
}

.miniiot-history-status-badge.status-offline {
  background-color: rgba(239, 68, 68, 0.15);
  color: #f87171;
}

.miniiot-history-status-badge.status-warning {
  background-color: rgba(245, 158, 11, 0.15);
  color: #fbbf24;
}

.miniiot-history-status-badge.status-maintenance {
  background-color: rgba(59, 130, 246, 0.15);
  color: #60a5fa;
}

.miniiot-history-status-badge.status-unknown {
  background-color: rgba(107, 114, 128, 0.15);
  color: #9ca3af;
}

/* NTP badge */
.miniiot-ntp-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 600;
}

.miniiot-ntp-badge.synced {
  background-color: rgba(34, 197, 94, 0.15);
  color: #4ade80;
}

.miniiot-ntp-badge.not-synced {
  background-color: rgba(239, 68, 68, 0.15);
  color: #f87171;
}

/* ========== History Tabs ========== */
.miniiot-history-tabs {
  display: flex;
  gap: 4px;
  margin-bottom: 14px;
  background-color: rgba(255, 255, 255, 0.04);
  border-radius: 8px;
  padding: 3px;
}

.miniiot-history-tab {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 9px 12px;
  background: transparent;
  border: none;
  border-radius: 6px;
  color: #9ca3af;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  font-family: inherit;
}

.miniiot-history-tab:hover {
  color: #d1d5db;
  background-color: rgba(255, 255, 255, 0.04);
}

.miniiot-history-tab.active {
  color: #c4b5fd;
  background-color: rgba(139, 92, 246, 0.15);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.miniiot-tab-count {
  font-size: 10px;
  padding: 1px 6px;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.08);
  color: inherit;
  font-weight: 700;
}

.miniiot-history-tab.active .miniiot-tab-count {
  background-color: rgba(139, 92, 246, 0.25);
}

/* ========== Command Status Badges ========== */
.miniiot-cmd-type-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
  background-color: rgba(59, 130, 246, 0.15);
  color: #60a5fa;
}

.miniiot-cmd-status-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
}

.miniiot-cmd-status-badge.cmd-completed {
  background-color: rgba(34, 197, 94, 0.15);
  color: #4ade80;
}

.miniiot-cmd-status-badge.cmd-sent {
  background-color: rgba(59, 130, 246, 0.15);
  color: #60a5fa;
}

.miniiot-cmd-status-badge.cmd-pending {
  background-color: rgba(245, 158, 11, 0.15);
  color: #fbbf24;
}

.miniiot-cmd-status-badge.cmd-failed {
  background-color: rgba(239, 68, 68, 0.15);
  color: #f87171;
}

.miniiot-cmd-status-badge.cmd-unknown {
  background-color: rgba(107, 114, 128, 0.15);
  color: #9ca3af;
}

/* ========== History Date Filters ========== */
.miniiot-history-filters {
  display: flex;
  align-items: flex-end;
  gap: 10px;
  margin-bottom: 14px;
  flex-wrap: wrap;
}

.miniiot-history-filter-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.miniiot-filter-label {
  font-size: 11px;
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.miniiot-filter-input {
  padding: 7px 10px;
  background-color: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  color: #e5e7eb;
  font-size: 12px;
  font-family: inherit;
  outline: none;
  transition: border-color 0.2s;
}

.miniiot-filter-input:focus {
  border-color: rgba(139, 92, 246, 0.5);
}

.miniiot-filter-input::-webkit-calendar-picker-indicator {
  filter: invert(0.7);
  cursor: pointer;
}

.miniiot-filter-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 7px 14px;
  border: none;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s, opacity 0.2s;
  font-family: inherit;
  white-space: nowrap;
}

.miniiot-filter-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.miniiot-filter-btn.apply {
  background-color: rgba(139, 92, 246, 0.2);
  color: #c4b5fd;
}

.miniiot-filter-btn.apply:hover:not(:disabled) {
  background-color: rgba(139, 92, 246, 0.35);
}

.miniiot-filter-btn.clear {
  background-color: rgba(255, 255, 255, 0.06);
  color: #9ca3af;
}

.miniiot-filter-btn.clear:hover:not(:disabled) {
  background-color: rgba(255, 255, 255, 0.1);
  color: #d1d5db;
}

/* Uptime cell */
.miniiot-uptime-cell {
  font-weight: 600;
  font-size: 12px;
  color: #a5b4fc;
  font-family: 'JetBrains Mono', 'Fira Code', monospace;
}

/* Actuator Status */
.miniiot-actuator-cell {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.miniiot-actuator-row {
  display: flex;
  align-items: center;
  gap: 6px;
}

.miniiot-actuator-badge {
  display: inline-block;
  padding: 2px 7px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 600;
  text-transform: capitalize;
}

.miniiot-actuator-badge.available {
  background-color: rgba(34, 197, 94, 0.15);
  color: #4ade80;
}

.miniiot-actuator-badge.error {
  background-color: rgba(239, 68, 68, 0.15);
  color: #f87171;
}

.miniiot-actuator-count {
  font-size: 10px;
  color: #9ca3af;
  font-weight: 500;
}

.miniiot-actuator-clients {
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
}

.miniiot-actuator-client {
  display: inline-block;
  padding: 1px 6px;
  background-color: rgba(255, 255, 255, 0.06);
  border-radius: 4px;
  font-size: 10px;
  font-family: 'JetBrains Mono', 'Fira Code', monospace;
  color: #d1d5db;
}

.miniiot-actuator-na {
  color: #6b7280;
  font-size: 11px;
}

/* Animations */
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.spin {
  animation: spin 1s linear infinite;
}
`, "",{"version":3,"sources":["webpack://./src/pages/MiniIOTPage.css"],"names":[],"mappings":"AAAA,iDAAiD;AACjD,kDAAkD;AAClD,iDAAiD;;AAEjD;EACE,SAAO;EACP,aAAa;EACb,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,YAAY;AACZ;EACE,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa;EACb,8CAA8C;EAC9C,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,kDAAkD;AACpD;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,2DAA2D;AAC7D;;AAEA,eAAe;AACf;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iCAAiC;AACjC;;;EAGE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,2DAA2D;AAC7D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,2DAA2D;EAC3D,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,QAAQ;EACR,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;EACzC,oCAAoC;AACtC;;AAEA;EACE,yCAAyC;EACzC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6CAA6C;EAC7C,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,wCAAwC;AACxC;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,2CAA2C;EAC3C,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gDAAgD;EAChD,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kDAAkD;EAClD,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,qDAAqD;EACrD,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,0CAA0C;EAC1C,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,gDAAgD;AAChD;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,cAAc;AAChB;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,2CAA2C;EAC3C,0CAA0C;EAC1C,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,+CAA+C;EAC/C,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,qDAAqD;AACvD;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,qDAAqD;EACrD,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,eAAe;AACf;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kCAAkC;AACpC","sourcesContent":["/* ============================================ */\n/* MiniIOT Page                                  */\n/* ============================================ */\n\n.miniiot-page {\n  flex: 1;\n  padding: 24px;\n  background-color: #0a0a0a;\n  color: #ffffff;\n  height: 100%;\n  width: 100%;\n  overflow-y: auto;\n  margin: 0;\n  box-sizing: border-box;\n}\n\n.miniiot-container {\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n/* Header */\n.miniiot-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.miniiot-header-icon {\n  width: 40px;\n  height: 40px;\n  background-color: #dc2626;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  flex-shrink: 0;\n}\n\n.miniiot-title {\n  font-size: 24px;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0;\n  line-height: 1.2;\n}\n\n.miniiot-subtitle {\n  font-size: 13px;\n  color: #9ca3af;\n  margin: 0;\n}\n\n/* Layout */\n.miniiot-layout {\n  display: grid;\n  grid-template-columns: 1fr 2fr;\n  gap: 16px;\n}\n\n@media (max-width: 1024px) {\n  .miniiot-layout {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Sidebar */\n.miniiot-sidebar-card {\n  background-color: #1a1a1a;\n  border-radius: 10px;\n  border: 1px solid #2a2a2a;\n  padding: 12px;\n}\n\n.miniiot-search-container {\n  position: relative;\n  margin-bottom: 12px;\n}\n\n.miniiot-search-icon {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #6b7280;\n  pointer-events: none;\n}\n\n.miniiot-search-input {\n  width: 100%;\n  padding: 10px 16px 10px 40px;\n  background-color: #0a0a0a;\n  border: 1px solid #374151;\n  border-radius: 8px;\n  color: #ffffff;\n  font-size: 14px;\n  outline: none;\n  transition: border-color 0.2s, box-shadow 0.2s;\n  box-sizing: border-box;\n}\n\n.miniiot-search-input::placeholder {\n  color: #6b7280;\n}\n\n.miniiot-search-input:focus {\n  border-color: #dc2626;\n  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.15);\n}\n\n/* Sites List */\n.miniiot-sites-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  max-height: calc(100vh - 250px);\n  overflow-y: auto;\n}\n\n.miniiot-sites-list::-webkit-scrollbar {\n  width: 4px;\n}\n\n.miniiot-sites-list::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.miniiot-sites-list::-webkit-scrollbar-thumb {\n  background: #374151;\n  border-radius: 4px;\n}\n\n/* Section Headers */\n.miniiot-section-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 8px;\n  margin-bottom: 6px;\n}\n\n.miniiot-section-header.online {\n  margin-top: 0;\n}\n\n.miniiot-section-header.offline {\n  margin-top: 0;\n}\n\n.miniiot-section-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.miniiot-section-label {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #9ca3af;\n  flex: 1;\n}\n\n.miniiot-section-badge {\n  font-size: 10px;\n  font-weight: 700;\n  color: #9ca3af;\n  background-color: #2a2a2a;\n  padding: 1px 7px;\n  border-radius: 10px;\n  min-width: 18px;\n  text-align: center;\n}\n\n.miniiot-section-divider {\n  height: 1px;\n  background-color: #2a2a2a;\n  margin: 12px 0;\n}\n\n.miniiot-section-empty {\n  padding: 12px 8px;\n  text-align: center;\n}\n\n.miniiot-section-empty p {\n  font-size: 12px;\n  color: #4b5563;\n  margin: 0;\n}\n\n.miniiot-searching-indicator {\n  color: #818cf8;\n  text-transform: none;\n  animation: miniiot-pulse 1.2s ease-in-out infinite;\n}\n\n@keyframes miniiot-pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.4; }\n}\n\n.miniiot-site-item {\n  width: 100%;\n  text-align: left;\n  padding: 12px;\n  background-color: #0a0a0a;\n  border: 2px solid #2a2a2a;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n  color: inherit;\n  font-family: inherit;\n}\n\n.miniiot-site-item:hover {\n  border-color: #4b5563;\n}\n\n.miniiot-site-item.selected {\n  border-color: #dc2626;\n  background-color: rgba(220, 38, 38, 0.08);\n}\n\n.miniiot-site-item-content {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.miniiot-site-item-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.miniiot-site-item-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: #ffffff;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.miniiot-site-item-neighborhood {\n  font-size: 12px;\n  color: #9ca3af;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.miniiot-site-item-serial {\n  font-size: 11px;\n  color: #6b7280;\n  margin-top: 4px;\n  font-family: 'SF Mono', 'Fira Code', 'Fira Mono', monospace;\n}\n\n/* Status Dot */\n.miniiot-status-dot {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  margin-top: 4px;\n}\n\n.miniiot-status-dot.status-online {\n  background-color: #22c55e;\n  box-shadow: 0 0 6px rgba(34, 197, 94, 0.5);\n}\n\n.miniiot-status-dot.status-offline {\n  background-color: #ef4444;\n  box-shadow: 0 0 6px rgba(239, 68, 68, 0.5);\n}\n\n.miniiot-status-dot.status-warning {\n  background-color: #f59e0b;\n  box-shadow: 0 0 6px rgba(245, 158, 11, 0.5);\n}\n\n.miniiot-status-dot.status-maintenance {\n  background-color: #3b82f6;\n  box-shadow: 0 0 6px rgba(59, 130, 246, 0.5);\n}\n\n.miniiot-status-dot.status-unknown {\n  background-color: #6b7280;\n}\n\n/* Loading, Error, Empty States */\n.miniiot-loading,\n.miniiot-empty,\n.miniiot-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 16px;\n  text-align: center;\n}\n\n.miniiot-loading p,\n.miniiot-empty p {\n  font-size: 13px;\n  color: #6b7280;\n  margin: 8px 0 0;\n}\n\n.miniiot-error p {\n  font-size: 13px;\n  color: #ef4444;\n  margin: 0 0 12px;\n}\n\n.miniiot-spinner {\n  width: 32px;\n  height: 32px;\n  border: 3px solid #2a2a2a;\n  border-top-color: #dc2626;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n.miniiot-retry-btn {\n  padding: 8px 16px;\n  background-color: #dc2626;\n  color: #ffffff;\n  border: none;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.miniiot-retry-btn:hover {\n  background-color: #b91c1c;\n}\n\n/* Main Panel */\n.miniiot-detail-panels {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.miniiot-card {\n  background-color: #1a1a1a;\n  border-radius: 10px;\n  border: 1px solid #2a2a2a;\n  padding: 20px;\n}\n\n.miniiot-card-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  margin-bottom: 16px;\n  gap: 12px;\n}\n\n.miniiot-card-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0 0 2px;\n}\n\n.miniiot-card-subtitle {\n  font-size: 12px;\n  color: #9ca3af;\n  margin: 0;\n}\n\n/* Device Status Badge */\n.miniiot-device-status-badge {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.miniiot-status-indicator {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  display: inline-block;\n}\n\n.miniiot-status-indicator.status-online {\n  background-color: #22c55e;\n  box-shadow: 0 0 6px rgba(34, 197, 94, 0.5);\n}\n\n.miniiot-status-indicator.status-offline {\n  background-color: #ef4444;\n}\n\n.miniiot-status-indicator.status-warning {\n  background-color: #f59e0b;\n}\n\n.miniiot-status-indicator.status-maintenance {\n  background-color: #3b82f6;\n}\n\n.miniiot-status-indicator.status-unknown {\n  background-color: #6b7280;\n}\n\n.miniiot-status-text {\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.miniiot-status-text.status-online {\n  color: #22c55e;\n}\n\n.miniiot-status-text.status-offline {\n  color: #ef4444;\n}\n\n.miniiot-status-text.status-warning {\n  color: #f59e0b;\n}\n\n.miniiot-status-text.status-maintenance {\n  color: #3b82f6;\n}\n\n.miniiot-status-text.status-unknown {\n  color: #6b7280;\n}\n\n/* Info Grid */\n.miniiot-info-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n@media (max-width: 768px) {\n  .miniiot-info-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.miniiot-info-item {\n  background-color: #0a0a0a;\n  border-radius: 8px;\n  padding: 12px;\n  border: 1px solid #2a2a2a;\n}\n\n.miniiot-info-label {\n  font-size: 11px;\n  font-weight: 600;\n  color: #6b7280;\n  margin-bottom: 4px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.miniiot-info-value {\n  font-size: 14px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.miniiot-info-value.mono,\n.mono {\n  font-family: 'SF Mono', 'Fira Code', 'Fira Mono', monospace;\n}\n\n.miniiot-info-label-with-action {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 4px;\n}\n\n.miniiot-info-label-icon {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.miniiot-info-date-block {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.miniiot-info-date-label {\n  font-size: 11px;\n  color: #6b7280;\n}\n\n.miniiot-refresh-btn {\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  border-radius: 50%;\n  color: #6b7280;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.miniiot-refresh-btn:hover {\n  background-color: #374151;\n  color: #dc2626;\n}\n\n.miniiot-refresh-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Section Title */\n.miniiot-section-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0 0 16px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* Commands Grid */\n.miniiot-commands-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n}\n\n@media (max-width: 768px) {\n  .miniiot-commands-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.miniiot-command-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.miniiot-command-btn {\n  width: 100%;\n  padding: 16px;\n  background-color: #0a0a0a;\n  border: 2px solid #2a2a2a;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  color: inherit;\n  font-family: inherit;\n}\n\n.miniiot-command-btn:hover:not(:disabled) {\n  border-color: #dc2626;\n}\n\n.miniiot-command-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.miniiot-command-btn:disabled:hover {\n  border-color: #2a2a2a;\n}\n\n.miniiot-command-icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s;\n}\n\n.miniiot-command-icon.blue {\n  background-color: rgba(59, 130, 246, 0.15);\n  color: #3b82f6;\n}\n\n.miniiot-command-btn:hover:not(:disabled) .miniiot-command-icon.blue {\n  background-color: rgba(59, 130, 246, 0.25);\n}\n\n.miniiot-command-icon.red {\n  background-color: rgba(220, 38, 38, 0.15);\n  color: #dc2626;\n}\n\n.miniiot-command-btn:hover:not(:disabled) .miniiot-command-icon.red {\n  background-color: rgba(220, 38, 38, 0.25);\n}\n\n.miniiot-command-icon.yellow {\n  background-color: rgba(245, 158, 11, 0.15);\n  color: #f59e0b;\n}\n\n.miniiot-command-btn:hover:not(:disabled) .miniiot-command-icon.yellow {\n  background-color: rgba(245, 158, 11, 0.25);\n}\n\n.miniiot-command-text {\n  text-align: center;\n}\n\n.miniiot-command-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: #ffffff;\n  margin-bottom: 2px;\n}\n\n.miniiot-command-desc {\n  font-size: 12px;\n  color: #6b7280;\n  line-height: 1.3;\n}\n\n/* Report Link */\n.miniiot-report-link {\n  margin-top: 8px;\n  text-align: center;\n}\n\n.miniiot-report-link-btn {\n  background: none;\n  border: none;\n  color: #6b7280;\n  font-size: 12px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  transition: color 0.2s;\n  font-family: inherit;\n  text-decoration: underline;\n}\n\n.miniiot-report-link-btn:hover {\n  color: #dc2626;\n}\n\n/* Info Command */\n.miniiot-info-command-section {\n  margin-top: 16px;\n  padding-top: 16px;\n  border-top: 1px solid #2a2a2a;\n}\n\n.miniiot-info-command-btn {\n  width: 100%;\n  padding: 10px 16px;\n  background-color: #0a0a0a;\n  border: 1px solid #2a2a2a;\n  border-radius: 8px;\n  color: #9ca3af;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  font-family: inherit;\n}\n\n.miniiot-info-command-btn:hover:not(:disabled) {\n  border-color: #3b82f6;\n  color: #3b82f6;\n  background-color: rgba(59, 130, 246, 0.05);\n}\n\n.miniiot-info-command-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n/* Progress Bar */\n.miniiot-progress-container {\n  margin-top: 16px;\n  padding: 12px;\n  background-color: #0a0a0a;\n  border-radius: 8px;\n  border: 1px solid #2a2a2a;\n}\n\n.miniiot-progress-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.miniiot-progress-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.miniiot-progress-percent {\n  font-size: 13px;\n  font-family: 'SF Mono', 'Fira Code', 'Fira Mono', monospace;\n  color: #6b7280;\n}\n\n.miniiot-progress-bar {\n  width: 100%;\n  height: 6px;\n  background-color: #2a2a2a;\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.miniiot-progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #dc2626, #ef4444);\n  border-radius: 6px;\n  transition: width 0.3s ease-out;\n}\n\n/* Empty State */\n.miniiot-empty-state {\n  background-color: #1a1a1a;\n  border-radius: 10px;\n  border: 1px solid #2a2a2a;\n  padding: 80px 40px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n\n.miniiot-empty-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #6b7280;\n  margin: 16px 0 8px;\n}\n\n.miniiot-empty-desc {\n  font-size: 14px;\n  color: #4b5563;\n  margin: 0;\n  max-width: 320px;\n}\n\n/* Modal */\n.miniiot-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 50;\n  padding: 16px;\n  backdrop-filter: blur(4px);\n}\n\n.miniiot-modal {\n  background-color: #1a1a1a;\n  border-radius: 12px;\n  border: 1px solid #2a2a2a;\n  max-width: 720px;\n  width: 100%;\n  max-height: 80vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);\n}\n\n.miniiot-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px;\n  border-bottom: 1px solid #2a2a2a;\n}\n\n.miniiot-modal-header-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.miniiot-modal-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0;\n}\n\n.miniiot-modal-subtitle {\n  font-size: 12px;\n  color: #6b7280;\n  margin: 2px 0 0;\n}\n\n.miniiot-modal-close {\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  color: #6b7280;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.miniiot-modal-close:hover {\n  background-color: #2a2a2a;\n}\n\n.miniiot-modal-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.miniiot-modal-body::-webkit-scrollbar {\n  width: 4px;\n}\n\n.miniiot-modal-body::-webkit-scrollbar-thumb {\n  background: #374151;\n  border-radius: 4px;\n}\n\n/* Report Items */\n.miniiot-report-item {\n  padding: 16px;\n  border-radius: 10px;\n  border: 2px solid;\n}\n\n.miniiot-report-item.success {\n  background-color: rgba(34, 197, 94, 0.05);\n  border-color: rgba(34, 197, 94, 0.3);\n}\n\n.miniiot-report-item.error {\n  background-color: rgba(239, 68, 68, 0.05);\n  border-color: rgba(239, 68, 68, 0.3);\n}\n\n.miniiot-report-item-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.miniiot-report-item-icon {\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.miniiot-report-item-details {\n  flex: 1;\n  min-width: 0;\n}\n\n.miniiot-report-item-title-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 4px;\n}\n\n.miniiot-report-item-title {\n  font-size: 15px;\n  font-weight: 600;\n  color: #ffffff;\n  margin: 0;\n}\n\n.miniiot-report-badge {\n  font-size: 11px;\n  font-weight: 600;\n  padding: 2px 8px;\n  border-radius: 4px;\n}\n\n.miniiot-report-badge.success {\n  background-color: rgba(34, 197, 94, 0.15);\n  color: #22c55e;\n}\n\n.miniiot-report-badge.error {\n  background-color: rgba(239, 68, 68, 0.15);\n  color: #ef4444;\n}\n\n.miniiot-report-message {\n  font-size: 13px;\n  margin: 0 0 8px;\n}\n\n.miniiot-report-message.success {\n  color: #4ade80;\n}\n\n.miniiot-report-message.error {\n  color: #f87171;\n}\n\n.miniiot-report-meta {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 6px;\n  font-size: 12px;\n}\n\n.miniiot-report-meta-item {\n  display: flex;\n  gap: 6px;\n}\n\n.miniiot-report-meta-item.full {\n  grid-column: 1 / -1;\n}\n\n.miniiot-report-meta-label {\n  color: #6b7280;\n}\n\n.miniiot-report-meta-value {\n  color: #ffffff;\n  font-weight: 500;\n}\n\n/* Modal Footer */\n.miniiot-modal-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  border-top: 1px solid #2a2a2a;\n}\n\n.miniiot-modal-count {\n  font-size: 13px;\n  color: #6b7280;\n  margin: 0;\n}\n\n.miniiot-modal-count span {\n  color: #ffffff;\n  font-weight: 600;\n}\n\n.miniiot-modal-close-btn {\n  padding: 8px 20px;\n  background-color: #dc2626;\n  color: #ffffff;\n  border: none;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  font-family: inherit;\n}\n\n.miniiot-modal-close-btn:hover {\n  background-color: #b91c1c;\n}\n\n.miniiot-modal-empty {\n  text-align: center;\n  padding: 40px 16px;\n}\n\n.miniiot-modal-empty p {\n  color: #6b7280;\n  font-size: 14px;\n}\n\n/* ========== History Toggle Button ========== */\n.miniiot-history-toggle-btn {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 12px 16px;\n  background: transparent;\n  border: none;\n  color: #a78bfa;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: color 0.2s, background-color 0.2s;\n  border-radius: 8px;\n  font-family: inherit;\n}\n\n.miniiot-history-toggle-btn:hover {\n  color: #c4b5fd;\n  background-color: rgba(139, 92, 246, 0.08);\n}\n\n.miniiot-history-toggle-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.miniiot-chevron {\n  margin-left: auto;\n  transition: transform 0.3s ease;\n}\n\n.miniiot-chevron.open {\n  transform: rotate(180deg);\n}\n\n/* ========== History Panel ========== */\n.miniiot-history-panel {\n  max-height: 500px;\n  display: flex;\n  flex-direction: column;\n}\n\n.miniiot-history-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n\n.miniiot-history-count {\n  font-size: 12px;\n  color: #9ca3af;\n  background-color: rgba(255, 255, 255, 0.05);\n  padding: 3px 10px;\n  border-radius: 12px;\n}\n\n.miniiot-history-empty {\n  text-align: center;\n  padding: 30px 16px;\n}\n\n.miniiot-history-empty p {\n  color: #6b7280;\n  font-size: 14px;\n  margin-top: 8px;\n}\n\n.miniiot-history-table-wrapper {\n  overflow: auto;\n  max-height: 400px;\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.miniiot-history-table-wrapper::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n.miniiot-history-table-wrapper::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.miniiot-history-table-wrapper::-webkit-scrollbar-thumb {\n  background: #374151;\n  border-radius: 3px;\n}\n\n.miniiot-history-table-wrapper::-webkit-scrollbar-thumb:hover {\n  background: #4b5563;\n}\n\n.miniiot-history-table-wrapper::-webkit-scrollbar-corner {\n  background: transparent;\n}\n\n.miniiot-history-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  font-size: 12px;\n  min-width: 580px;\n}\n\n.miniiot-history-table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  background-color: #1e1b2e;\n  color: #c4b5fd;\n  font-weight: 600;\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  padding: 10px 12px;\n  text-align: left;\n  white-space: nowrap;\n  border-bottom: 2px solid rgba(139, 92, 246, 0.3);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);\n}\n\n.miniiot-history-table td {\n  padding: 8px 12px;\n  color: #d1d5db;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.04);\n  white-space: nowrap;\n}\n\n.miniiot-history-table tbody tr:hover {\n  background-color: rgba(255, 255, 255, 0.03);\n}\n\n.miniiot-history-table .mono {\n  font-family: 'JetBrains Mono', 'Fira Code', monospace;\n  font-size: 11px;\n}\n\n.miniiot-history-date {\n  font-size: 11px;\n  color: #9ca3af;\n}\n\n/* History status badge */\n.miniiot-history-status-badge {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 10px;\n  font-size: 11px;\n  font-weight: 600;\n  text-align: center;\n}\n\n.miniiot-history-status-badge.status-online {\n  background-color: rgba(34, 197, 94, 0.15);\n  color: #4ade80;\n}\n\n.miniiot-history-status-badge.status-offline {\n  background-color: rgba(239, 68, 68, 0.15);\n  color: #f87171;\n}\n\n.miniiot-history-status-badge.status-warning {\n  background-color: rgba(245, 158, 11, 0.15);\n  color: #fbbf24;\n}\n\n.miniiot-history-status-badge.status-maintenance {\n  background-color: rgba(59, 130, 246, 0.15);\n  color: #60a5fa;\n}\n\n.miniiot-history-status-badge.status-unknown {\n  background-color: rgba(107, 114, 128, 0.15);\n  color: #9ca3af;\n}\n\n/* NTP badge */\n.miniiot-ntp-badge {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 10px;\n  font-size: 10px;\n  font-weight: 600;\n}\n\n.miniiot-ntp-badge.synced {\n  background-color: rgba(34, 197, 94, 0.15);\n  color: #4ade80;\n}\n\n.miniiot-ntp-badge.not-synced {\n  background-color: rgba(239, 68, 68, 0.15);\n  color: #f87171;\n}\n\n/* ========== History Tabs ========== */\n.miniiot-history-tabs {\n  display: flex;\n  gap: 4px;\n  margin-bottom: 14px;\n  background-color: rgba(255, 255, 255, 0.04);\n  border-radius: 8px;\n  padding: 3px;\n}\n\n.miniiot-history-tab {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  padding: 9px 12px;\n  background: transparent;\n  border: none;\n  border-radius: 6px;\n  color: #9ca3af;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  font-family: inherit;\n}\n\n.miniiot-history-tab:hover {\n  color: #d1d5db;\n  background-color: rgba(255, 255, 255, 0.04);\n}\n\n.miniiot-history-tab.active {\n  color: #c4b5fd;\n  background-color: rgba(139, 92, 246, 0.15);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n.miniiot-tab-count {\n  font-size: 10px;\n  padding: 1px 6px;\n  border-radius: 8px;\n  background-color: rgba(255, 255, 255, 0.08);\n  color: inherit;\n  font-weight: 700;\n}\n\n.miniiot-history-tab.active .miniiot-tab-count {\n  background-color: rgba(139, 92, 246, 0.25);\n}\n\n/* ========== Command Status Badges ========== */\n.miniiot-cmd-type-badge {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 10px;\n  font-size: 11px;\n  font-weight: 600;\n  background-color: rgba(59, 130, 246, 0.15);\n  color: #60a5fa;\n}\n\n.miniiot-cmd-status-badge {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 10px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.miniiot-cmd-status-badge.cmd-completed {\n  background-color: rgba(34, 197, 94, 0.15);\n  color: #4ade80;\n}\n\n.miniiot-cmd-status-badge.cmd-sent {\n  background-color: rgba(59, 130, 246, 0.15);\n  color: #60a5fa;\n}\n\n.miniiot-cmd-status-badge.cmd-pending {\n  background-color: rgba(245, 158, 11, 0.15);\n  color: #fbbf24;\n}\n\n.miniiot-cmd-status-badge.cmd-failed {\n  background-color: rgba(239, 68, 68, 0.15);\n  color: #f87171;\n}\n\n.miniiot-cmd-status-badge.cmd-unknown {\n  background-color: rgba(107, 114, 128, 0.15);\n  color: #9ca3af;\n}\n\n/* ========== History Date Filters ========== */\n.miniiot-history-filters {\n  display: flex;\n  align-items: flex-end;\n  gap: 10px;\n  margin-bottom: 14px;\n  flex-wrap: wrap;\n}\n\n.miniiot-history-filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.miniiot-filter-label {\n  font-size: 11px;\n  font-weight: 600;\n  color: #9ca3af;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.miniiot-filter-input {\n  padding: 7px 10px;\n  background-color: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 6px;\n  color: #e5e7eb;\n  font-size: 12px;\n  font-family: inherit;\n  outline: none;\n  transition: border-color 0.2s;\n}\n\n.miniiot-filter-input:focus {\n  border-color: rgba(139, 92, 246, 0.5);\n}\n\n.miniiot-filter-input::-webkit-calendar-picker-indicator {\n  filter: invert(0.7);\n  cursor: pointer;\n}\n\n.miniiot-filter-btn {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  padding: 7px 14px;\n  border: none;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s, opacity 0.2s;\n  font-family: inherit;\n  white-space: nowrap;\n}\n\n.miniiot-filter-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.miniiot-filter-btn.apply {\n  background-color: rgba(139, 92, 246, 0.2);\n  color: #c4b5fd;\n}\n\n.miniiot-filter-btn.apply:hover:not(:disabled) {\n  background-color: rgba(139, 92, 246, 0.35);\n}\n\n.miniiot-filter-btn.clear {\n  background-color: rgba(255, 255, 255, 0.06);\n  color: #9ca3af;\n}\n\n.miniiot-filter-btn.clear:hover:not(:disabled) {\n  background-color: rgba(255, 255, 255, 0.1);\n  color: #d1d5db;\n}\n\n/* Uptime cell */\n.miniiot-uptime-cell {\n  font-weight: 600;\n  font-size: 12px;\n  color: #a5b4fc;\n  font-family: 'JetBrains Mono', 'Fira Code', monospace;\n}\n\n/* Actuator Status */\n.miniiot-actuator-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.miniiot-actuator-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.miniiot-actuator-badge {\n  display: inline-block;\n  padding: 2px 7px;\n  border-radius: 10px;\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: capitalize;\n}\n\n.miniiot-actuator-badge.available {\n  background-color: rgba(34, 197, 94, 0.15);\n  color: #4ade80;\n}\n\n.miniiot-actuator-badge.error {\n  background-color: rgba(239, 68, 68, 0.15);\n  color: #f87171;\n}\n\n.miniiot-actuator-count {\n  font-size: 10px;\n  color: #9ca3af;\n  font-weight: 500;\n}\n\n.miniiot-actuator-clients {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 3px;\n}\n\n.miniiot-actuator-client {\n  display: inline-block;\n  padding: 1px 6px;\n  background-color: rgba(255, 255, 255, 0.06);\n  border-radius: 4px;\n  font-size: 10px;\n  font-family: 'JetBrains Mono', 'Fira Code', monospace;\n  color: #d1d5db;\n}\n\n.miniiot-actuator-na {\n  color: #6b7280;\n  font-size: 11px;\n}\n\n/* Animations */\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.spin {\n  animation: spin 1s linear infinite;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
